import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequest } from '../../../helpers/api/createRequest';
import * as documentsApi from '../../../api/docs';
import { Thunk } from '../../../helpers/redux/Thunk';
import { AdditionalSettings } from '../../../types/Endpoints/documents/DocumentsContracts';
import { getAdditionalSettings } from './getAdditionalSettings';

export const UPDATE_ADDITIONAL_SETTINGS = 'additionalSettings/updateAdditionalSettings';

const onSuccess = (): Thunk => async dispatch => {
    dispatch(getAdditionalSettings());
};

export const updateAdditionalSettings = createAsyncThunk(
    UPDATE_ADDITIONAL_SETTINGS,
    createRequest({
        type: UPDATE_ADDITIONAL_SETTINGS,
        loader: async (requestData: AdditionalSettings) => documentsApi.updateAdditionalSettings(requestData),
        onSuccess,
    }),
);
